var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Artboard","transform":"translate(-1241.000000, -19.000000)","fillRule":"nonzero","fill":"#FFFFFF"},React.createElement("g",{"id":"Group-9"},React.createElement("polygon",{"id":"arrow","points":"1241.55452 29.5545227 1242.44548 30.4454773 1247.89095 25 1242.44548 19.5545227 1241.55452 20.4454773 1246.10905 25"}))))]);
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;



//////////////////
// WEBPACK FOOTER
// ./src/layouts/arrow.svg
// module id = 472
// module chunks = 114276838955818